import axios from "axios";
import { AppEnvironment } from "../utils/constants/Global";
import { generateLog } from "../utils/constants/Logger";

class HttpService {
  apiBaseURL = process.env.REACT_APP_API_URL;
  options = {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    // fileheaders: {
    //   'Content-Type': 'multipart/form-data',
    // },
    // chatBot: {
    //   'Content-Type': 'application/x-www-form-urlencoded',
    // }
  };

  // GET Method 
  get(url, queryParams, headers = null) {
    if (headers) headers = { ...this.options.headers, ...headers };
    return this.makeRequest('get', url, { headers, params: queryParams });
  }

  // POST Method
  post(url, data, queryParams = null, headers = null, mediaType = null) {
    if (headers) headers = { ...this.options.headers, ...headers };
    let responseType = mediaType ? { responseType: 'blob' } : undefined;
    return this.makeRequest('post', url, data, { headers, ...responseType });
  }

//   postFile(url, data, queryParams = null, headers = null) {
//     if (headers) headers = { ...this.options.fileheaders, ...headers };
//     return this.makeRequest('post', url, data, { headers });
//   }

//   postChatBot(url, data, queryParams = null, headers = null) {
//     if (headers) headers = { ...this.options.fileheaders, ...headers };
//     return this.makeRequest('post', '../' + url, data, { headers });
//   }

  // Generic request method
  makeRequest(method, url, data, config = {}) {
    return new Promise((resolve, reject) => {
      axios[method](this.apiBaseURL + '/' + url, data, config)
        .then((response) => {
          generateLog('default', `AXIOS ${method.toUpperCase()} Success Response`, JSON.stringify(response));
          resolve(response.data);
        })
        .catch((error) => {
          generateLog('error', `AXIOS ${method.toUpperCase()} Error Response`, error);
          if (error.response) {
            if (error.response.status >= 400 && error.response.status < 500) {
              reject(error.response.data);
            } else {
              const message = {
                title: "Server Error",
                content: "Please try again later"
              };
              error.response.data = { message };
              reject(error.response.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }
}

export const httpService = new HttpService();



